/** Whether Administration says "No branch yet": only once the list has answered with none. */
export function saysNoBranch(read: boolean, branch: unknown): boolean {
  return read && !branch
}
